'use client';
import { lazy, Suspense, useRef, type ComponentProps } from 'react';
export type * from "/tmp/build-86/node_modules/@eliadmin/core/src/components/product/detail/tabs/product-tab-reviews.tsx";
type Props = NonNullable<ComponentProps<typeof import("/tmp/build-86/node_modules/@eliadmin/core/src/components/product/detail/tabs/product-tab-reviews.tsx").ProductTabReviews>>;
const Deferred = lazy(() => import("@eliadmin/commerce-original/reviews").then(m => ({ default: m.ProductTabReviews })));
export function ProductTabReviews(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }
